import { Button } from "@softmax/design-system";
import type { useEditorReorder } from "./use-editor-reorder";

type EditorReorderButtonsProps = Readonly<{
  index: number;
  item: "link" | "media item";
  reorder: ReturnType<typeof useEditorReorder>;
}>;

export function EditorReorderButtons({
  index,
  item,
  reorder,
}: EditorReorderButtonsProps) {
  const moves = [
    { direction: -1, label: item === "link" ? "up" : "earlier", glyph: "↑" },
    { direction: 1, label: item === "link" ? "down" : "later", glyph: "↓" },
  ] as const;

  return (
    <>
      {moves.map(({ direction, label, glyph }) => (
        <Button
          key={direction}
          size="sm"
          variant="quiet"
          aria-label={`Move ${item} ${index + 1} ${label}`}
          {...reorder.buttonProps({ index, direction })}
        >
          {glyph}
        </Button>
      ))}
    </>
  );
}
